import { trainingInfo, trainingOption1Bundle} from './TurkeyTournamentData'
import PurchaseList from '../../components/PurchaseList';
import Location from '../../components/Location.jsx'
import LogisiticsDetails from '../../components/LogisiticsDetails';
import FoxLakeLogo from '../../static/FoxLakeLogo.png'
import 'animate.css';

export default function TurkeyPickleballTourney() {
  return (
    <section className="section d-flex flex-column align-items-center justify-content-center">
      <div className="info camps__container animate__animated animate__fadeInRight">
        <h4>November 21st Thanksgiving Pickle Ball Tournament</h4>
        <h4 className='disclaimer'>Mixed, Mens, Womens, 18+ All Pairs are Welcome</h4>
        <div className='camp__container'>
          <div className="purchase">
          <PurchaseList 
            type="ThreeDayBundle"
            header="Team Registration"
            subhead="Click To Register"
            data={trainingOption1Bundle}
          />
           <img
              className="img-fluid mb-4 pl-0"
              src={FoxLakeLogo}
              alt="Fox Lake Logo"
            />
        </div>
        <div className='logistics'>
    
       <Location 
            link="https://maps.app.goo.gl/bzJQMCjncGWaXhTH6"
            name="Lotus Elementary School"
            street="29067 W Grass Lake Rd"
            city=" Fox Lake, IL 60020"
          />
          <LogisiticsDetails 
            header="Important Notes"
            data={trainingInfo}
          />
        </div>

      </div>
      {/* close camp container div */}
    </div>
    {/* close info div */}
  </section>
)
}